import LockIcon from '@mui/icons-material/Lock';
// material-ui
import { Button, CardContent, Grid, Typography } from '@mui/material';
// project imports
import { FormattedMessage } from 'react-intl';
import MainCard from 'components/cards/MainCard';

import keycloak from '../../Keycloak';

const BlockedUser = () => {
    return (
        <Grid
            container
            justifyContent="center"
            alignItems="flex-start"
            borderRadius={2}
            sx={{
                minHeight: '70vh',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.80)'
            }}
        >
            <MainCard
                sx={{
                    mt: '15vh',
                    minWidth: '300px',
                    maxWidth: '500px',
                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                    '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
                    }
                }}
            >
                <CardContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        padding: '0px'
                    }}
                >
                    <LockIcon sx={{ fontSize: 45 }} />
                    <Typography variant="h2" mt={1} mb={'8px!important'}>
                        <FormattedMessage id="USUARIO_BLOQUEADO" />
                    </Typography>
                    <Typography variant="body2" mt={0}>
                        <FormattedMessage id="POR_FAVOR_CONTACTE_CON_EL_EQUIPO_DE_RUBRICAE" />
                    </Typography>
                    <Typography variant="body1" fontWeight={500} color="primary" mt={2}>
                        clientes@rubricae.com
                    </Typography>
                    <Button
                        sx={{ mt: '10px' }}
                        variant="contained"
                        onClick={() => {
                            keycloak.logout();
                        }}
                    >
                        Cerrar sesion
                    </Button>
                </CardContent>
            </MainCard>
        </Grid>
    );
};

export default BlockedUser;
